<template>
  <v-container>
    <!-- DESKTOP LOGIN FORM -->
    <v-form v-if="!mobile" class="col-lg-5 col-10 login-form cyan lighten-5" align="center" justify="center">
      <v-row>
        <v-text-field prepend-icon="material-icons email" label="Email" hint="max 30 characters"  height="30" :value="username"/>
      </v-row>

      <v-row>
        <v-text-field prepend-icon="material-icons lock" label="Password" hint="min 8 characters" height="30" :value="password"/>
      </v-row>

      <br />

      <v-row>
        <v-btn>Forgot password</v-btn>
        <v-spacer />
        <v-btn>Login</v-btn> 
      </v-row>
    </v-form>

    <!-- MOBILE LOGIN FORM -->
    <v-form v-else-if="mobile" class="col-lg-5 col-10 login-form cyan lighten-5" align="center" justify="center">
      <v-row>
        <v-text-field prepend-icon="material-icons email" label="Email" hint="max 30 characters"  height="30" :value="username"/>
      </v-row>

      <v-row>
        <v-text-field prepend-icon="material-icons lock" label="Password" hint="min 8 characters" height="30" :value="password"/>
      </v-row>

      <br />

      <v-row justify="center">
        <v-btn>Login</v-btn> 
      </v-row>

      <br />

      <v-row justify="center">
        <v-btn>Forgot password</v-btn>
      </v-row>
    </v-form>
    <br />

    <v-row class="col-lg-5 col-10 signup-link" justify="center">
      <p class="cyan--text">Don't have a account yet?</p>

      <span class="register-btn">
        <v-btn v-if="!mobile">
          <router-link to="register">Register</router-link>
        </v-btn>
      </span>

      <br v-if="mobile" />
      <v-btn v-if="mobile" justify="center">
        <router-link to="register">Register</router-link>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'login-form',

  data: () => ({
    username: '',
    password: ''
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    }
  }
}
</script>

<style scoped>
.login-form {
  padding: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.5rem;
  box-shadow: -0.5px 1.5px 0.25rem 0.5px rgba(0,0,0,0.25)
}

.signup-link {
  margin-left: auto;
  margin-right: auto;
}

.register-btn {
  margin-left: 1rem !important
}

span a {
  text-decoration: none
}
</style>
